import { IconButton, Tooltip } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import PublicIcon from "@mui/icons-material/Public";

const ICONS = {
  filtered: <FilterAltIcon />,
  all: <PublicIcon />
};

const TOOLTIPS = {
  filtered: "Show all conversations (across tabs)",
  all: "Show only this tab's conversation"
};

const ScoutThreadHeaderToggle = ({ viewMode, onToggle }) => (
  <Tooltip title={TOOLTIPS[viewMode]}>
    <IconButton onClick={onToggle} aria-label={TOOLTIPS[viewMode]}>
      {ICONS[viewMode]}
    </IconButton>
  </Tooltip>
);

export default ScoutThreadHeaderToggle;
